module.exports = __webpack_public_path__ + "img/update.af4d3f04.svg";